import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DTypeTableField } from '@grupo-constant/next-dtype/form';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { DtypeTableWithFixedRowsComponent } from './components/tablewithfixedrows/tablewithfixedrows.component';
import { DtypeTableWithVariableRowsComponent } from './components/tablewithvariablerows/tablewithvariablerows.component';


@Component({
    selector: 'table-field-component',
    templateUrl: './table-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DtypeTableWithVariableRowsComponent, DtypeTableWithFixedRowsComponent]
})
export class DtypeTableFieldComponent implements DTypeFormFieldComponent {

    @Input() field: DTypeTableField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;


    constructor() { }
}


